import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=dd2b08ac&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd2b08ac')) {
      api.createRecord('dd2b08ac', component.options)
    } else {
      api.reload('dd2b08ac', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=dd2b08ac&", function () {
      api.rerender('dd2b08ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-83lxCq9rDfx75/JS/comp/IncreaseNumber.vue"
export default component.exports